import { Fleet } from '@src/main/modules/parameters/domain/fleet-positions/fleet.interface';
import { FleetRepository } from '@src/main/modules/parameters/domain/fleet-positions/fleet.repository';

export const findAllFleets = async (repository: FleetRepository): Promise<Fleet[]> =>
  await repository.findAll();
